import styled from 'styled-components'
import { Spinner } from '@/components/common/etc'
import { LayoutHeader } from '@/components/domains/layouts'
import { useSellersQuery } from '@/graphql/generated/hooks'

const PageSellers = () => {
  const { data, loading: isLoading } = useSellersQuery({
    variables: {
      filter: {
        status: {
          include: ['APPROVED'],
        },
      },
    },
  })

  const tempList = data?.sellers?.edges.map((edge) => edge.node) || []
  const sellerList = tempList.filter((item): item is { id: string; shopName: string } => item !== undefined)

  return (
    <>
      <LayoutHeader />
      {isLoading && <Spinner wrap />}
      {!isLoading && (
        <StyledUl>
          <StyledLi>판매자(셀러)</StyledLi>
          {sellerList.map((seller) => (
            <StyledLi key={seller.id}>{seller.shopName}</StyledLi>
          ))}
        </StyledUl>
      )}
    </>
  )
}

export default PageSellers

const StyledUl = styled.ul`
  list-style: none;
  :first-child {
    font-weight: bold;
  }
`

const StyledLi = styled.li`
  padding: 0.8rem 0 0.8rem 1rem;
  border-bottom: 1px solid #eaeaea;
`
